
import axiosInstance from '../utils/AxiosConfig';

import { DEFAULT_CURRENCY, getActiveCurrency } from '../utils/currency';
export const getCostsDashboardData = async () => {
  const response = await axiosInstance.get('/reports/cost', { params: getActiveCurrency() !== DEFAULT_CURRENCY ? { currency: getActiveCurrency() } : {} });
  return response.data;
};
